import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  allFleetHubAPI,
  fleetRecordsWithIdAPI,
  fleetFormDropdownListsAPI,
} from "../api/procurement";

export const fleetFormDropdownListsThunk = createAsyncThunk(
  "dashboard/fleet/dropdownlist",
  async () => {
    try {
      const response = await fleetFormDropdownListsAPI();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const allFleetHubTable = createAsyncThunk("dashboard/fleet", async (hubId) => {
  try {
    const response_array = await allFleetHubAPI(hubId);
    const ansArray = [];
    response_array?.results?.fleets?.map((response) => {
      let filtered_reponse = {};
      const vehicle_filtered = {};
      const vehicle_docs_records = response?.vehicle_docs;
      for (let j = 0; j < vehicle_docs_records?.length; j++) {
        const record_name = vehicle_docs_records[j].document_type;
        vehicle_filtered[record_name] = { ...vehicle_docs_records[j] };
      }
      filtered_reponse = {
        ...response,
        vehicle_docs: vehicle_filtered,
      };
      ansArray.push(filtered_reponse);
      // return filtered_reponse;
      // return response;
    });
    return ansArray;
  } catch (error) {
    return error;
  }
});

export const fetchFleetDetailsWithId = createAsyncThunk(
  "dashboard/fleet/details",
  async (fleetId) => {
    try {
      const response = await fleetRecordsWithIdAPI(fleetId);
      let filtered_reponses = {};
      const vehicle_filtered = {};
      const vehicle_docs_records = response?.results?.vehicle_docs;
      for (let j = 0; j < vehicle_docs_records?.length; j++) {
        const record_name = vehicle_docs_records[j].document_type;
        vehicle_filtered[record_name] = { ...vehicle_docs_records[j] };
      }
      filtered_reponses = {
        ...response?.results,
        vehicle_docs: vehicle_filtered,
      };
      return filtered_reponses;
    } catch (error) {
      return error;
      // throw error
    }
  }
);

//For Image only;
export const fetchFleetImagesWithId = createAsyncThunk(
  "dashboard/fleets/images",
  async (fleetId) => {
    try {
      const response = await fleetRecordsWithIdAPI(fleetId);
      let filtered_reponse = {};
      const vehicle_filtered = {};
      const vehicle_docs_records = response?.results?.vehicle_docs;
      for (let j = 0; j < vehicle_docs_records?.length; j++) {
        const record_name = vehicle_docs_records[j].document_type;
        vehicle_filtered[record_name] = { ...vehicle_docs_records[j] };
      }
      filtered_reponse = {
        ...response?.results,
        vehicle_docs: vehicle_filtered,
      };
      return filtered_reponse;
    } catch (error) {
      return error;
    }
  }
);

const allFleetHubAPIOptionsSlice = createSlice({
  name: "allFleetHub",
  initialState: {
    data: [],
    error: null,
    isLoading: false,
    recordCounts: 0,
    records: [],
    procurementRecords: [],
  },
  reducers: {
    allfleetReduxDetails: (state, action) => {
      state.data = action.payload;
    },
    recordCountReduxDetails: (state, action) => {
      state.recordCounts = action.payload;
    },
    procurementFilteredRecords: (state, action) => {
      state.procurementRecords = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(allFleetHubTable.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(allFleetHubTable.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = Array.isArray(action.payload) ? action.payload : [];
      state.records = Array.isArray(action?.payload)
        ? action?.payload?.map((record) => {
            const vehicleDoc = record?.vehicle_docs;
            const obj = {};
            //Base data

            obj["car_type_details"] = record?.car_type_details;
            obj["car_type"] = record?.car_type_details?.id;
            obj["chassis_number"] = record?.chassis_number;
            obj["createdAt"] = record?.createdAt;
            obj["createdAt"] = record?.createdAt;
            obj["deletedAt"] = record?.deletedAt;
            obj["hub_name"] = record?.hub?.hub_name;
            obj["primary_hub"] = record?.primary_hub?.hub_name; //
            obj["hub_id"] = record?.hub_id;
            obj["id"] = record?.id;
            obj["model"] = record?.model;
            obj["odometer_reading"] = record?.odometer_reading;
            obj["parkingremarks"] = record?.parkingremarks;
            obj["procured_by"] = record?.procured_by;
            obj["procurementremarks"] = record?.procurementremarks;
            obj["reg_number"] = record?.reg_number;
            obj["status"] = record?.status;
            obj["uber_vehicle_id"] = record?.uber_vehicle_id;
            obj["updatedAt"] = record?.updatedAt;
            obj["variant"] = record?.variant;
            obj["engine_number"] = record?.engine_number;

            //vehicle_additional_detail
            record = record?.vehicle_additional_detail;
            obj["discount"] = record?.discount;
            obj["ex_showroom_price"] = record?.ex_showroom_price;
            obj["financier"] = record?.financier;
            obj["fund_amount"] = record?.fund_amount;
            obj["manufacturing_year"] = record?.manufacturing_year;
            obj["registration_date"] = record?.registration_date;
            obj["roi"] = record?.roi;
            obj["seller"] = record?.seller;
            obj["tenure"] = record?.tenure;
            obj["emi_start_date"] = record?.emi_start_date;
            obj["loan_account_number"] = record?.loan_account_number;

            //vehicle_docs
            obj["insuranceNumber"] = vehicleDoc?.Insurance?.document_number;
            obj["insuranceStartDate"] =
              vehicleDoc?.Insurance?.start_date &&
              new Date(vehicleDoc?.Insurance?.start_date).toLocaleDateString();
            obj["insuranceEndDate"] =
              vehicleDoc?.Insurance?.end_date &&
              new Date(vehicleDoc?.Insurance?.end_date).toLocaleDateString();
            obj["insuranceType"] = vehicleDoc?.Insurance?.company;
            obj["Insurance"] = vehicleDoc?.Insurance?.photos;
            obj["Tax"] = vehicleDoc?.Tax?.photos;
            obj["fasttagNumber"] = vehicleDoc?.Fastag?.document_number;
            obj["fastagCompany"] = vehicleDoc?.Fastag?.company;
            obj["Fastag"] = vehicleDoc?.Fastag?.photos;
            obj["pollutionCertificateStartDate"] =
              vehicleDoc?.PollutionCertificate?.start_date &&
              new Date(vehicleDoc?.PollutionCertificate?.start_date).toLocaleDateString();
            obj["pollutionCertificateEndDate"] =
              vehicleDoc?.PollutionCertificate?.end_date &&
              new Date(vehicleDoc?.PollutionCertificate?.end_date).toLocaleDateString();
            obj["PollutionCertificate"] = vehicleDoc?.PollutionCertificate?.photos;
            obj["fitnessCertificateEndDate"] =
              vehicleDoc?.FitnessCertificate?.end_date &&
              new Date(vehicleDoc?.FitnessCertificate?.end_date).toLocaleDateString();
            obj["FitnessCertificate"] = vehicleDoc?.FitnessCertificate?.photos;
            obj["permitNumber"] = vehicleDoc?.Permit?.document_number;
            obj["permitType"] = vehicleDoc?.Permit?.company;
            obj["permitEndsDate"] =
              vehicleDoc?.Permit?.end_date &&
              new Date(vehicleDoc?.Permit?.end_date).toLocaleDateString();
            obj["Permit"] = vehicleDoc?.Permit?.photos;
            obj["authorisationNumber"] = vehicleDoc?.Authorisation?.document_number;
            obj["authorisationEndDate"] =
              vehicleDoc?.Authorisation?.end_date &&
              new Date(vehicleDoc?.Authorisation?.end_date).toLocaleDateString();
            obj["Authorisation"] = vehicleDoc?.Authorisation?.photos;
            return obj;
          })
        : [];

      // {
      //     "status": element?.status,
      //     "reg_number": element?.reg_number,
      //     "chassis_number": element?.chassis_number,
      //     "engine_number": element?.engine_number,
      //     "hub_name": element?.hub_name,
      //     "model": element?.model,
      //     "variant": element?.variant,
      //     "manufacturing_year": element?.manufacturing_year,
      //     "seller": element?.seller,
      //     "ex_showroom_price": element?.ex_showroom_price,
      //     "discount": element?.discount,
      //     "registration_date": element?.registration_date,
      //     "financier": element?.financier,
      //     "emi_start_date": element?.emi_start_date,
      //     "loan_account_number": element?.loan_account_number,
      //     "fund_amount": element?.fund_amount,
      //     "roi": element?.roi,
      //     "tenure": element?.tenure,
      //     "procurementremarks": element?.procurementremarks,
      //     "id":element?.id
      //   }

      //Procurement Only Filtered
      state.procurementRecords = Array.isArray(action?.payload)
        ? action?.payload
            ?.map((record) => {
              const obj = {};
              obj["reg_number"] = record?.reg_number; //
              obj["chassis_number"] = record?.chassis_number; //
              obj["createdAt"] = record?.createdAt;
              obj["hub_name"] = record?.hub?.hub_name; //
              obj["status"] = record?.status; //
              obj["variant"] = record?.variant; //
              obj["model"] = record?.model; //
              obj["ex_showroom_price"] = record?.vehicle_additional_detail?.ex_showroom_price; //
              obj["fund_amount"] = record?.vehicle_additional_detail?.fund_amount; //
              obj["manufacturing_year"] = record?.vehicle_additional_detail?.manufacturing_year; //
              obj["registration_date"] = record?.vehicle_additional_detail?.registration_date; //
              obj["emi_start_date"] = record?.vehicle_additional_detail?.emi_start_date; //
              obj["loan_account_number"] = record?.vehicle_additional_detail?.loan_account_number; //
              obj["hub_id"] = record?.hub_id; //
              obj["procured_by"] = record?.procured_by; //
              obj["procurementremarks"] = record?.procurementremarks; //
              obj["engine_number"] = record?.engine_number; //
              obj["id"] = record?.id; //
              obj["discount"] = record?.vehicle_additional_detail?.discount; //
              obj["financier"] = record?.vehicle_additional_detail?.financier; //
              obj["roi"] = record?.vehicle_additional_detail?.roi; //
              obj["seller"] = record?.vehicle_additional_detail?.seller; //
              obj["tenure"] = record?.vehicle_additional_detail?.tenure; //
              return obj;
            })
            ?.reverse()
        : [];
    });
    builder.addCase(allFleetHubTable.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

const fleetFormDropdownListsSlice = createSlice({
  name: "allFleetHub",
  initialState: {
    dropdownData: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    fleetFormDropdownListsReducer: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fleetFormDropdownListsThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fleetFormDropdownListsThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload ? action.payload : {};
      // state.fleetId = state.data?.id
    });
    builder.addCase(fleetFormDropdownListsThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

const fleetWithIdSlice = createSlice({
  name: "fleetWithId",
  initialState: {
    data: {},
    detailsUpdatedFleetId: null,
    procurement: {},
    procurementUpdated: {},
    parking: {},
    parkingUpdated: {},
    error: null,
    isLoading: false,
    tempObjInitialState: {},
    recordCounts: 0,
    recovery_agent_name: "",
    recovery_agent_dropdown: [],
    images: {},
  },
  reducers: {
    updatefleetOnboardingDetails: (state, action) => {
      state.procurement = action.payload;
      state.data = action.payload.data;
      // state.procurement = {...action.payload.data, ...action.payload.procurement}
      state.fleetId = action.payload.fleetId;
    },
    updateProcurementDetails: (state, action) => {
      state.procurementUpdated = action.payload.data;
      state.detailsUpdatedFleetId = action.payload.fleetId; //.id chance of failure
    },
    updateParkingReduxDetails: (state, action) => {
      state.parking = action.payload;
    },
    updatedParkingReduxDetails: (state, action) => {
      state.parkingUpdated = action.payload.data;
      state.detailsUpdatedFleetId = action.payload.id; //.id chance of failure
    },
    updateImagesReduxDetails: (state, action) => {
      // format:- {key:Insurance, value: [image1, image2, image3]}
      const imageArr = action.payload?.value || [];
      state.images[action.payload?.key] = imageArr;
      state.parking[action.payload?.key] = imageArr;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFleetDetailsWithId.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchFleetDetailsWithId.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.procurement = action.payload?.vehicle_additional_detail;
      const { vehicle_additional_detail, vehicle_docs, ...filteredData } = action.payload;
      state.procurement = { ...action.payload?.vehicle_additional_detail, ...filteredData };
      state.fleetId = state?.procurement?.id;
      //vehicle docs attributes filteration
      state.recovery_agent_dropdown = action.payload?.recoveries;
      action.payload?.recoveries?.map((record) => {
        if (!(record.recovery_status === "parked" || record.status === "parked")) {
          if (record?.recoveryAgent && Object.keys(record?.recoveryAgent)?.length !== 0)
            state.recovery_agent_name = `${record?.recoveryAgent?.first_name} ${record?.recoveryAgent?.last_name}`;
        }
      });
      const obj = {};
      const records = action?.payload?.vehicle_docs;
      obj["insuranceNumber"] = records?.Insurance?.document_number;
      obj["insuranceStartDate"] = records?.Insurance?.start_date;
      obj["insuranceEndDate"] = records?.Insurance?.end_date;
      obj["insuranceType"] = records?.Insurance?.company;
      obj["Insurance"] = records?.Insurance?.photos;

      state.images["Insurance"] = records?.Insurance?.photos;
      state.images["Tax"] = records?.Tax?.photos;
      state.images["Fastag"] = records?.Fastag?.photos;
      state.images["PollutionCertificate"] = records?.PollutionCertificate?.photos;
      state.images["FitnessCertificate"] = records?.FitnessCertificate?.photos;
      state.images["Permit"] = records?.Permit?.photos;
      state.images["Authorisation"] = records?.Authorisation?.photos;
      state.images["RC"] = records?.RC?.photos;
      state.images["Invoice"] = records?.Invoice?.photos;
      state.images["PDI"] = records?.PDI?.photos;

      obj["Tax"] = records?.Tax?.photos;
      obj["taxReceiptStartDate"] = records?.Tax?.start_date;
      obj["taxReceiptEndDate"] = records?.Tax?.end_date;
      obj["fasttagNumber"] = records?.Fastag?.document_number;
      obj["fastagCompany"] = records?.Fastag?.company;
      obj["Fastag"] = records?.Fastag?.photos;
      obj["pollutionCertificateStartDate"] = records?.PollutionCertificate?.start_date;
      obj["pollutionCertificateEndDate"] = records?.PollutionCertificate?.end_date;
      obj["PollutionCertificate"] = records?.PollutionCertificate?.photos;
      obj["fitnessCertificateEndDate"] = records?.FitnessCertificate?.end_date;
      obj["FitnessCertificate"] = records?.FitnessCertificate?.photos;
      obj["permitNumber"] = records?.Permit?.document_number;
      obj["permitCompany"] = records?.Permit?.company;
      obj["Permit"] = records?.Permit?.photos;
      obj["permitEndDate"] = records?.Permit?.end_date;
      obj["authorisationNumber"] = records?.Authorisation?.document_number;
      obj["authorisationEndDate"] = records?.Authorisation?.end_date;
      //Do it here previous are also wrong

      obj["Authorisation"] = records?.Authorisation?.photos;
      obj["taxReceiptStartDate"] = records?.Tax?.start_date;
      obj["taxReceiptEndDate"] = records?.Tax?.end_date;
      obj["Tax"] = records?.Tax?.photos;

      // RC Details
      obj["rcStartDate"] = records?.RC?.start_date;
      obj["rcCompany"] = records?.RC?.company;
      // obj["RC"] = records?.RC?.photos;

      // Invoice Details
      obj["invoiceNumber"] = records?.Invoice?.document_number;
      obj["invoiceStartDate"] = records?.Invoice?.start_date;
      obj["invoiceCompany"] = records?.Invoice?.company;
      // obj["Invoice"] = records?.Invoice?.photos;

      // PDI Details
      obj["Authorisation"] = records?.Authorisation?.photos;
      obj["fleetId"] = action.payload.id;

      state.parking = obj;
      state.tempObjInitialState = { ...state.procurement, ...state.parking };
    });
    builder.addCase(fetchFleetDetailsWithId.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

const fleetImageWithIdSlice = createSlice({
  name: "fleetImageWithId",
  initialState: {
    detailsUpdatedFleetId: null,
    parkingImage: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    parkingRemainingFields: (state, action) => {},
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFleetImagesWithId.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchFleetImagesWithId.fulfilled, (state, action) => {
      state.isLoading = false;
      state.fleetId = state?.procurement?.id;
      const obj = {};
      const records = action?.payload?.vehicle_docs;
      obj["Insurance"] = records?.Insurance?.photos;
      obj["Fastag"] = records?.Fastag?.photos;
      obj["PollutionCertificate"] = records?.PollutionCertificate?.photos;
      obj["FitnessCertificate"] = records?.FitnessCertificate?.photos;
      obj["Permit"] = records?.Permit?.photos;
      obj["Authorisation"] = records?.Authorisation?.photos;
      obj["Tax"] = records?.Tax?.photos;
      obj["RC"] = records?.RC?.photos;
      obj["Invoice"] = records?.Invoice?.photos;
      obj["PDI"] = records?.PDI?.photos;
      obj["fleetId"] = action.payload.id;

      state.parkingImage = obj;
    });
    builder.addCase(fetchFleetImagesWithId.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});
// export const driverDetailsWithId = driverDetailsWithIdSlice.reducer;
export const allFleetHubAPIDetails = allFleetHubAPIOptionsSlice.reducer;
export const fleetWithIdSliceDetails = fleetWithIdSlice.reducer;
export const fleetImageIdSliceDetails = fleetImageWithIdSlice.reducer;
export const fleetFormDropdownListsDetails = fleetFormDropdownListsSlice.reducer;
// export const updatedCountReduxDetails = fleetWithIdSlice.actions.updatedCountReduxDetails
// recordCountReduxDetails
export const updatefleetOnboardingDetails = fleetWithIdSlice.actions.updatefleetOnboardingDetails;
export const updateProcurementDetails = fleetWithIdSlice.actions.updateProcurementDetails;
export const updateParkingReduxDetails = fleetWithIdSlice.actions.updateParkingReduxDetails;
export const updatedParkingReduxDetails = fleetWithIdSlice.actions.updatedParkingReduxDetails;
export const updateImagesReduxDetails = fleetWithIdSlice.actions.updateImagesReduxDetails;
export const recordCountReduxDetails = allFleetHubAPIOptionsSlice.actions.recordCountReduxDetails;
export const procurementFilteredRecords =
  allFleetHubAPIOptionsSlice.actions.procurementFilteredRecords;
// export default rentalSchemeOptionsSlice.reducer;
